import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=eff8c7b0&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=eff8c7b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff8c7b0",
  null
  
)

component.options.__file = "src/components/user-avatar/UserAvatar.vue"
export default component.exports